// extracted by mini-css-extract-plugin
export var layoutContainer = "_58-0";
export var layoutContainerNoRounding = "_58-6";
export var layoutContainerOpen = "_58-5";
export var layoutContainerResizing = "_58-1";
export var mainContent = "_58-2";
export var resizeDivider = "_58-3";
export var slidePanel = "_58-4";